import { useMemo } from 'react';
import { usePeriodFormatter } from '../../lib/period/formatter';
import { useReportTypeName } from '../../lib/reportType/name';
import type { RmsReport } from '../../types';
import type { ReportRow } from '../types';

export const useReportRows = (reports: RmsReport[]): ReportRow[] => {
  const getReportTypeName = useReportTypeName();
  const formatPeriod = usePeriodFormatter();

  return useMemo(
    () =>
      reports.map((report) => ({
        ...report,
        reportTypeName: getReportTypeName(report.reportType),
        periodLabel: formatPeriod(report.period.from),
      })),
    [reports, getReportTypeName, formatPeriod]
  );
};
